import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "menu-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "flex flex-grow-1 align-items-center" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "submenu-list" }
const _hoisted_7 = {
  key: 0,
  class: "menuitem"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex flex-grow-1 align-items-center" }

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { ANALYTIC_FRONTEND_URL, SELECTED_NETWORK_NAME } from '@/helpers/networkParams.helper';
import { useUtils } from '@/composables/utils/useUtils';
import Icon from '@/components/icon/Icon.vue';
import { computed } from 'vue';
import {
  NETWORK_SUPPORTS_BRIDGE,
  NETWORK_SUPPORTS_CHARTS,
  NETWORK_SUPPORTS_FARMS,
  NETWORK_SUPPORTS_SINGLE_SIDE,
  NETWORK_SUPPORTS_YIELD_POOLS,
} from '@/helpers/supporting-features-in-network';
import { ROUTE } from '@/constants/PAGE_ROUTES';

type MenuItem = {
  label: string;
  to: string;
  externalLink?: boolean;
  items?: MenuItem[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'MainMenu',
  emits: ["click"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const { t } = useI18n();
const { state } = useStore();
const route = useRoute();
const router = useRouter();
const { openExternalLink } = useUtils();



const chartsLink = computed(() => {
  return `${ANALYTIC_FRONTEND_URL}?net=${SELECTED_NETWORK_NAME.toUpperCase()}`;
});

const items: MenuItem[] = [
  {
    label: t('mainMenu.swap'),
    to: ROUTE.SWAP,
  },
  {
    label: t('mainMenu.portfolios'),
    to: ROUTE.PORTFOLIOS,
  },
  { label: t('mainMenu.farming'), to: ROUTE.FARMING },
  { label: t('mainMenu.staking'), to: ROUTE.STAKING },
  { label: t('mainMenu.bridge'), to: ROUTE.BRIDGE },
  {
    label: t('mainMenu.charts'),
    to: chartsLink.value,
    externalLink: true,
  },
];
const isRouteToUnsupportedFunctionality = to => {
  return (
    (!NETWORK_SUPPORTS_BRIDGE && to === ROUTE.BRIDGE) ||
    (!NETWORK_SUPPORTS_FARMS && to === ROUTE.FARMING) ||
    (!NETWORK_SUPPORTS_YIELD_POOLS && to === ROUTE.STAKING) ||
    (!NETWORK_SUPPORTS_SINGLE_SIDE && to === ROUTE.SINGLE_SIDE) ||
    (!NETWORK_SUPPORTS_CHARTS && to === chartsLink.value)
  );
};
const onClickItem = item => {
  if (item.to) {
    if (!item.externalLink) {
      router.push(item.to);
    } else {
      openExternalLink(item.to);
    }
    emits('click');
  }
  if (item.items && !state.layout.isDesktop) {
    document.getElementById(item.label.toLowerCase())?.classList.toggle('expanded');
    document.getElementById(`${item.label.toLowerCase()}Toggle`)?.classList.toggle('rotate-180');
  }
};
const isActive = item => {
  return item.items
    ? item.items.find(el => route.path.includes(el.to))
    : route.path.includes(item.to);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["main-menu", _unref(state).layout.isDesktop ? 'desktop' : 'mobile'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (itemL1) => {
        return _createElementVNode("div", {
          key: itemL1.label,
          class: "menuitem"
        }, [
          (!isRouteToUnsupportedFunctionality(itemL1.to))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["flex menuitem-link align-items-center", { active: isActive(itemL1) }]),
                role: "button",
                onClick: ($event: any) => (onClickItem(itemL1))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", null, _toDisplayString(itemL1.label), 1),
                  (itemL1.externalLink)
                    ? (_openBlock(), _createBlock(Icon, {
                        key: 0,
                        name: "externalLink",
                        class: "ml-s1"
                      }))
                    : _createCommentVNode("", true),
                  (itemL1.items && !_unref(state).layout.isDesktop)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "ml-auto pi pi-chevron-down",
                        id: `${itemL1.label.toLowerCase()}Toggle`
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_2))
            : _createCommentVNode("", true),
          (itemL1.items)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "submenu",
                id: itemL1.label.toLowerCase()
              }, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemL1.items, (itemL2) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: itemL2.label
                    }, [
                      (!isRouteToUnsupportedFunctionality(itemL2.to))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex submenuitem-link align-items-center", { active: isActive(itemL2) }]),
                              role: "button",
                              onClick: ($event: any) => (onClickItem(itemL2))
                            }, [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(itemL2.label), 1)
                            ], 10, _hoisted_8)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ], 8, _hoisted_5))
            : _createCommentVNode("", true)
        ])
      }), 64))
    ])
  ], 2))
}
}

})